import numbro from 'numbro';

/**
 * format number using numbro library and format https://numbrojs.com/old-format.html // TODO: Update to new library
 * @param  {Object} options
 * @param  {string} [options.format]
 * @param  {number | string} options.value
 * @return {string}
 */
export const formatData = ({ format = '0,0', value }) => {
  if (value === 'INF_SENTINEL' || value === 'NAN_SENTINEL') {
    return '-';
  }
  if (format === null) {
    return value;
  }

  if (format === 'url') {
    return (
      <a href={value} target="blank">
        {value}
      </a>
    );
  }

  const containsDecimalPoints = format.includes('.');
  const isFormatToPercentage = format.includes('%');

  const isEuro = format.includes('€');
  const isGBP = format.includes('£');
  const isUSD = format.includes('$');

  if ((isNaN(value) || !isFormatToPercentage) && (typeof value === 'string' || format === 'text')) {
    return value;
  }

  if (isEuro || isGBP || isUSD) {
    const isAverageShorthand = format.includes('a'); // https://numbrojs.com/format.html#average
    return numbro(value).formatCurrency({
      average: isAverageShorthand,
      currencySymbol: isEuro ? '€' : isGBP ? '£' : '$',
      mantissa: containsDecimalPoints
        ? isAverageShorthand
          ? format.match(/\.(\d+)/)?.[1]?.length || 0
          : 2
        : 0,
      thousandSeparated: true,
    });
  }

  if (!containsDecimalPoints) {
    value = isFormatToPercentage ? value.toFixed(2) : Math.round(value);
  }
  return numbro(value).format(format);
};

/**
 * get information about user's locale
 * @param {string} countryCode abbreviated name for the country
 * @returns {Object}
 */
export const getLocaleInfo = (countryCode) => {
  switch (countryCode) {
    case 'CA':
      return {
        createdDateFormat: 'YYYY MMM D',
        locale: 'en-ca',
        numberLocale: 'en-CA',
      };
    case 'UK':
      return {
        createdDateFormat: 'D MMM YYYY',
        locale: 'en-gb',
        numberLocale: 'en-GB',
      };
    case 'US':
      return {
        createdDateFormat: 'MMM D, YYYY',
        locale: 'en',
        numberLocale: 'en-US',
      };

    default:
      return {};
  }
};

/**
 * truncate text with ellipsis
 * @param {Object} options
 * @param {number} [options.length]
 * @param {string} options.text
 * @returns {string}
 */
export const truncateTextWithEllipsis = ({ length = 60, text }) => {
  return text?.length > length ? text.substring(0, length) + '...' : text;
};
